// Direct imports - CraftJS requires synchronous component resolution
import { CardCraft } from './components/user/CardCraft';
import { Button } from './components/user/Button';
import { Text } from './components/user/Text';
import { RichText } from './components/user/RichText';
import { Container } from './components/user/Container';
import { Image } from './components/user/Image';
import { ImageInput } from './components/user/ImageInput';
import { Input } from './components/user/Input';
import { TextArea } from './components/user/TextArea_';
import { Carousel } from './components/user/Carousel';
import { BasicRecall } from './components/qwanyz/BasicRecall';
import { Layout } from './components/user/Layout';
import { RadioGroupComponent } from './components/user/RadioGroupComponent';
import { CheckboxGroupComponent } from './components/user/CheckboxGroupComponent';
import { ImageGrid } from './components/user/ImageGrid';
import { ListCraft } from './components/user/ListCraft';
import { StackCraft } from './components/user/StackCraft';
import { Select } from './components/user/Select';
import { Switch } from './components/user/Switch';
import { Table } from './components/user/Table';
import { Aggregator } from './components/user/Aggregator';
import { Link } from './components/user/Link';
import { IconButton } from './components/user/IconButton';
import { TabControl } from './components/user/TabControl';
import { NavbarControl } from './components/user/NavbarControl';
import { TabContainer } from './components/user/TabContainer';
import { Content } from './components/user/Content';
import { CopyButton } from './components/user/CopyButton';
import { MarkdownDisplay } from './components/user/MarkdownDisplay';
import { Shop } from './components/user/Shop';
import { RequestButton } from './components/user/RequestButton';
import { Website } from './components/user/Website';
import { Cart } from './components/user/Cart';

// Multiple exports from single file
import { 
  Requests, 
  RequestDeleteButton, 
  RequestDeleteCross, 
  RequestItemWrapper 
} from './components/user/Requests';

export const craftResolvers = {
  CardCraft,
  Button,
  Text,
  RichText,
  Container,
  Image,
  ImageInput,
  Carousel,
  Input,
  TextArea,
  BasicRecall,
  ImageGrid,
  Layout,
  RadioGroupComponent,
  CheckboxGroupComponent,
  ListCraft,
  StackCraft,
  Select,
  Switch,
  Table,
  Aggregator,
  Link,
  IconButton,
  TabControl,
  TabContainer,
  NavbarControl,
  Content,
  CopyButton,
  MarkdownDisplay,
  Shop,
  Requests,
  RequestButton,
  RequestDeleteButton,
  RequestDeleteCross,
  RequestItemWrapper,
  Website,
  Cart
};